<template>
	<v-tabs
		class="round-card"
		height="34"
		background-color="background-1"
		slider-color="primary">

		<v-tab :key="1" class="secondary-tab">Gestionali</v-tab>
		<v-tab :key="2" class="secondary-tab">Personalizzate</v-tab>
		<v-tab :key="3" class="secondary-tab">App</v-tab>
		<v-tab :key="4" class="secondary-tab">Website</v-tab>

		<v-tab-item :key="1" class="pb-offset background-1 pt-3">
			<v-container class="background-2 pa-0 round-card" fluid>
				<v-card class="background-2 round-card mb-0 elevation-1 pa-1">
					<v-row class="ma-0 pb-3 pb-offset">
						<v-col cols="12" class="pa-0">
							<v-stepper v-model="stepIndex" vertical non-linear class="elevation-0 w100p">
								<v-stepper-step editable :complete="stepIndex > 1" step="1">
									<span class="body-2">Seleziona quale applicazione integrare con GiveMeHive</span>
								</v-stepper-step>

								<v-stepper-content step="1">
									<v-card class="background-2 round-card mb-5">
										<v-row class="ma-0 pb-3">
											<v-col cols="12">	
												<v-radio-group v-model="settings['integrated_application']" class="pl-4 pt-3" :mandatory="false">
													<v-radio color="primary" label="Gamma Evolution" value="gamma_evolution"></v-radio>
													<v-radio color="primary" label="Gamma Sprint" value="gamma_sprint"></v-radio>
													<v-radio color="primary" label="Ad Hoc" value="adhoc"></v-radio>
													<v-radio color="primary" label="Reviso" value="reviso"></v-radio>
													<v-radio color="primary" label="FattureInCloud" value="fic"></v-radio>
													<v-radio color="primary" label="FattureInCloud V2" value="ficv2"></v-radio>
													<v-radio color="primary" label="King" value="king"></v-radio>
													<v-radio color="primary" label="Smack" value="smack"></v-radio>
													<v-radio color="primary" label="BusinessCube" value="business_cube"></v-radio>
													<v-radio color="primary" label="OS1" value="os1"></v-radio>
													<v-radio color="primary" label="Mexal" value="mexal"></v-radio>
													<v-radio color="primary" label="Nessuno" value="nothing"></v-radio>
												</v-radio-group>
											</v-col>
											<v-col cols="12" class="ml-3" v-show="settings['integrated_application'] == 'gamma_sprint'">
												<v-switch
													inset
													v-model="settings['sem_enabled']"
													label="Sync Real-Time Attivo?"
												></v-switch>
											</v-col>
											<v-col cols="12" class="ml-3" v-show="settings['integrated_application'] == 'reviso'">
												<v-switch
													inset
													v-model="settings['warehouse_enabled']"
													label="Modulo Magazzino attivo?"
												></v-switch>
											</v-col>
											<v-col cols="12" class="text-right pr-3" v-show="settings['integrated_application'] == 'reviso'">
												<v-spacer></v-spacer>
												<v-spacer></v-spacer>
												<v-btn class="mr-4" color="info" @click="loginReviso()">Login Reviso</v-btn>
											</v-col>
											<v-col cols="12" class="text-right pr-3" v-if="settings['integrated_application'] == 'fic'">
												<v-col class="px-4 pb-0" cols="12" lg="4" >
													<v-text-field
														label="API UID"
														v-model="settings['api_uid']"
														required
														:error-messages="errors.collect('API UID')"
														v-validate="'required'"
														data-vv-name="API UID"
														outlined
														dense
													></v-text-field>
												</v-col>
												<v-col class="px-4 pb-0" cols="12" lg="4" >
													<v-text-field
														label="API KEY"
														v-model="settings['api_key']"
														required
														:error-messages="errors.collect('API KEY')"
														v-validate="'required'"
														data-vv-name="API KEY"
														outlined
														dense
													></v-text-field>
												</v-col>
											</v-col>
											<v-col cols="12" class="text-right pr-3" v-if="settings['integrated_application'] == 'business_cube'">
												<v-col class="px-4 pb-0" cols="12" lg="4" >
													<v-text-field
														label="Codice Ditta"
														v-model="settings['business_code']"
														required
														:error-messages="errors.collect('Codice Ditta')"
														v-validate="'required'"
														data-vv-name="Codice Ditta"
														outlined
														dense
													></v-text-field>
												</v-col>
											</v-col>
											<v-col cols="12" class="text-right pr-3" v-if="settings['integrated_application'] == 'ficv2'">
												<v-col class="px-4 pb-0" cols="12" lg="4" >
													<v-text-field
														label="CLIENT ID"
														v-model="settings['client_id']"
														required
														:error-messages="errors.collect('CLIENT ID')"
														v-validate="'required'"
														data-vv-name="CLIENT ID"
														outlined
														dense
													></v-text-field>
												</v-col>
												<v-col class="px-4 pb-0" cols="12" lg="4" >
													<v-text-field
														label="CLIENT SECRET"
														v-model="settings['client_secret']"
														type="password"
														required
														:error-messages="errors.collect('CLIENT SECRET')"
														v-validate="'required'"
														data-vv-name="CLIENT SECRET"
														outlined
														dense
													></v-text-field>
												</v-col>
												<v-col class="px-4 pb-0" cols="12" lg="4" v-if="info['user_companies']">
													<v-autocomplete
														autocomplete="no"
														label="Azienda"
														:items="info['user_companies']"
														hint="Selezione l'azienda da collegare"
														persistent-hint
														v-model="settings['user_company']"
														item-text="name"
														item-value="id"
														clearable
														:error-messages="errors.collect('Azienda')"
														v-validate="'required'"
														data-vv-validate-on="input"
														data-vv-name="Azienda"
														:auto-select-first="true"
														outlined dense
														></v-autocomplete>
												</v-col>
												<v-spacer></v-spacer>
												<v-spacer></v-spacer>
												<v-btn class="mr-4" color="info" @click="loginFIC()">Login FattureInCloud</v-btn>
											</v-col>
										</v-row>
									</v-card>
									<v-btn class="my-4" color="primary" :disabled="settings['integrated_application'] == 'nothing'" @click="gestIntegratedApplication()">Continua</v-btn>
								</v-stepper-content>

								<v-stepper-step editable :complete="stepIndex > 2" step="2"><span class="body-2">Modalità di sincronizzazione</span></v-stepper-step>

								<v-stepper-content step="2">
									<v-card class="background-2 round-card mb-5">
										<v-container class="pa-0" fluid>
											<v-row class="ma-0 px-4">
												<v-col cols="12">
													<v-radio-group v-model="settings['integration_type']" class="pl-2" :mandatory="false">
														<v-radio color="primary" label="Server" value="server"></v-radio>
														<v-radio color="primary" label="FTP" value="ftp"></v-radio>
														<v-radio color="primary" label="Database" value="db"></v-radio>
													</v-radio-group>
												</v-col>

												<v-col class="px-4 pb-2" cols="12" lg="4" v-if="settings['integration_type'] == 'server'">
													<v-text-field
														label="Path"
														v-model="settings['server_path']"
														required
														:error-messages="errors.collect('Path')"
														v-validate="'required'"
														data-vv-name="Path"
														outlined
														dense
													></v-text-field>
												</v-col>	
												<template v-else-if="settings['integration_type'] == 'ftp'">
													<v-col class="px-4 pb-2" cols="12" lg="3">
														<v-text-field
															label="Hostname"
															v-model="settings['ftp_hostname']"
															required
															:error-messages="errors.collect('Hostname')"
															v-validate="'required'"
															data-vv-name="Hostname"
															outlined
															dense
														></v-text-field>
													</v-col>
													<v-col class="px-4 pb-2" cols="12" lg="3">
														<v-text-field
															label="Username"
															v-model="settings['ftp_username']"
															required
															:error-messages="errors.collect('Username')"
															v-validate="'required'"
															data-vv-name="Username"
															outlined
															dense
														></v-text-field>
													</v-col>															
													<v-col class="px-4 pb-2" cols="12" lg="3">
														<v-text-field
															label="Password"
															type="password"
															v-model="settings['ftp_password']"
															required
															:error-messages="errors.collect('Password')"
															v-validate="'required'"
															data-vv-name="Password"
															outlined
															dense
														></v-text-field>
													</v-col>															
													<v-col class="px-4 pb-2" cols="12" lg="3">
														<v-text-field
															label="Porta"
															v-model="settings['ftp_port']"
															required
															:error-messages="errors.collect('Porta')"
															v-validate="'required'"
															data-vv-name="Porta"
															outlined
															dense
														></v-text-field>
													</v-col>
												</template>
												<template v-else-if="settings['integration_type'] == 'db'">
													<v-col class="px-4 pb-2" cols="12" lg="3">
														<v-text-field
															label="Hostname"
															v-model="settings['db_hostname']"
															required
															:error-messages="errors.collect('Hostname')"
															v-validate="'required'"
															data-vv-name="Hostname"
															outlined
															dense
														></v-text-field>
													</v-col>
													<v-col class="px-4 pb-2" cols="12" lg="3">
														<v-text-field
															label="Username"
															v-model="settings['db_username']"
															required
															:error-messages="errors.collect('Username')"
															v-validate="'required'"
															data-vv-name="Username"
															outlined
															dense
														></v-text-field>
													</v-col>															
													<v-col class="px-4 pb-2" cols="12" lg="3">
														<v-text-field
															label="Password"
															type="password"
															v-model="settings['db_password']"
															required
															:error-messages="errors.collect('Password')"
															v-validate="'required'"
															data-vv-name="Password"
															outlined
															dense
														></v-text-field>
													</v-col>															
													<v-col class="px-4 pb-2" cols="12" lg="3">
														<v-text-field
															label="Porta"
															v-model="settings['db_port']"
															required
															:error-messages="errors.collect('Porta')"
															v-validate="'required'"
															data-vv-name="Porta"
															outlined
															dense
														></v-text-field>
													</v-col>

													<v-col class="px-4 pb-2" cols="12" lg="3">
														<v-text-field
															label="Database"
															v-model="settings['db_database']"
															required
															:error-messages="errors.collect('Database')"
															v-validate="'required'"
															data-vv-name="Database"
															outlined
															dense
														></v-text-field>
													</v-col>
												</template>
											</v-row>
										</v-container>
									</v-card>
									<v-btn class="my-4" color="primary" :disabled="!settings['integration_type']" @click="validateSyncType()">Continua</v-btn>
									<v-btn class="my-4" @click="stepIndex--" text>Indietro</v-btn>
								</v-stepper-content>

								<v-stepper-step editable :complete="stepIndex > 3" step="3"><span class="body-2">Aziende</span></v-stepper-step>
								<v-stepper-content step="3">
									<v-card color="background-2 round-card" class="mb-5">
										<v-subheader>Entrata</v-subheader>
										<v-container class="pa-0" fluid >
											<v-row class="ma-0 px-4">
												<v-col class="px-4 pt-0 pb-0" cols="12">
													<v-switch
														inset
														label="Aziende"
														color="primary"
														v-model="settings['import_companies']"
														hide-details
													></v-switch>
													<v-switch v-if="settings['import_companies']"
														inset
														label="Non aggiornare Aziende"
														color="primary"
														v-model="settings['import_not_update_companies']"
														hide-details
													></v-switch>
													<v-switch v-if="settings['integrated_application'] == 'gamma_sprint' && settings['import_companies']"
														inset
														label="Disabilita Aziende non lette"
														color="primary"
														v-model="settings['disable_companies']"
													></v-switch>															
												</v-col>
												<v-col class="px-4 pt-0" cols="12" lg="3" v-if="settings['import_companies']">
													<v-combobox
														label="Categorie escluse"
														hint="Inserisci i codici delle categorie da non importare"
														persistent-hint
														v-model="settings['import_companycategories_exluded']"
														small-chips
														:disabled="!settings['import_companies']"
														multiple
														return-object
														item-text="label"
														item-value="key"
														outlined
														dense
													></v-combobox>
												</v-col>													
												<v-col class="px-4 pt-0" cols="12" lg="3" v-if="settings['import_companies']">
													<v-combobox
														label="Aree aziende"
														hint="Inserisci i codici delle aree da non importare"
														persistent-hint
														v-model="settings['import_companyareas_exluded']"
														small-chips
														:disabled="!settings['import_companies']"
														multiple
														return-object
														item-text="label"
														item-value="key"
														outlined
														dense
													></v-combobox>
												</v-col>
												<v-col class="px-4 pt-0 pb-0" cols="12" v-if="settings['import_companies'] && ['gamma_evolution', 'gamma_sprint', 'business_cube', 'os1'].includes(settings['integrated_application'])">
													<v-switch
														inset
														label="Destinazioni"
														color="primary"
														v-model="settings['import_destinations']"
														hide-details
													></v-switch>
													<v-switch
														inset
														label="Contatti"
														color="primary"
														v-model="settings['import_contacts']"
														hide-details
													></v-switch>
													<v-switch
														inset
														label="Scadenze pagamenti"
														color="primary"
														v-model="settings['import_unsolveds']"
													></v-switch>
												</v-col>														
											</v-row>
										</v-container>

									</v-card>

									<v-card color="background-2 round-card" class="mb-5">
										<v-subheader>Uscita</v-subheader>
										<v-container class="pa-0" fluid>
											<v-row class="ma-0 px-4">
												<v-col class="px-4 pt-0 pb-4" cols="12">
													<v-switch
														inset
														label="Aziende"
														color="primary"
														v-model="settings['export_companies']"
													></v-switch>
													<v-switch
														inset
														label="Destinazioni"
														color="primary"
														v-model="settings['export_destinations']"
														hide-details																
													></v-switch>
												</v-col>
												<v-col class="px-4 pt-0" cols="12" lg="3">
													<v-combobox
														label="Categorie escluse"
														hint="Inserisci i codici delle categorie da non esportare"
														persistent-hint
														v-model="settings['export_companycategories_exluded']"
														small-chips
														:disabled="!settings['export_companies']"
														multiple
														return-object
														item-text="label"
														item-value="key"
														outlined
														dense
													></v-combobox>
												</v-col>													
												<v-col class="px-4 pt-0" cols="12" lg="3">
													<v-combobox
														label="Aree aziende"
														hint="Inserisci i codici delle aree da non esportare"
														persistent-hint
														v-model="settings['export_companyareas_exluded']"
														small-chips
														:disabled="!settings['export_companies']"
														multiple
														return-object
														item-text="label"
														item-value="key"
														outlined
														dense
													></v-combobox>
												</v-col>
												<v-col class="px-4 pt-0" cols="12" lg="3" v-if="info.company_status">
													<v-autocomplete
														label="Stato aziende"
														hint="Inserisci gli stati delle azienda da esportare"
														persistent-hint
														:items="info.company_status"
														v-model="settings['export_companystatus_included']"
														small-chips
														:disabled="!settings['export_companies']"
														multiple
														item-text="text"
														item-value="value"
														outlined
														dense
													></v-autocomplete>
												</v-col>
												<v-col class="px-4 pt-0" cols="12" lg="3" v-if="info.payment_term">
													<v-autocomplete
														label="Condizione di pagamento di default"
														hint="Inserisci la condizione di pagamento di default per le aziende che non lo hanno"
														persistent-hint
														:items="info.payment_term"
														v-model="settings['export_company_payment_term']"
														small-chips
														:disabled="!settings['export_companies']"
														item-text="text"
														item-value="value"
														outlined
														dense>
														<template v-slot:item="data">
															<v-list-item-content>
																<v-list-item-title v-html="data.item.text"></v-list-item-title>
																<v-list-item-subtitle v-html="data.item.value"></v-list-item-subtitle>
															</v-list-item-content>
														</template>			
													</v-autocomplete>
												</v-col>
												<v-col class="px-4 pt-0 pb-4" cols="12" v-if="settings['export_companies'] && ['business_cube'].includes(settings['integrated_application'])">
													<v-switch
														inset
														label="Contatti"
														color="primary"
														v-model="settings['export_contacts']"
														hide-details
													></v-switch>
												</v-col>												
											</v-row>
										</v-container>
									</v-card>

									<v-btn class="my-4" color="primary" @click="stepIndex++">Continua</v-btn>
									<v-btn class="my-4" @click="backIntegretedApplication()" text>Indietro</v-btn>
								</v-stepper-content>

								<v-stepper-step editable :complete="stepIndex > 4" step="4"><span class="body-2">Preventivi</span></v-stepper-step>
								<v-stepper-content step="4">

									<v-card color="background-2 round-card" class="mb-5">
										<v-subheader>Entrata</v-subheader>
										<v-container class="pa-0" fluid>
																					<v-row class="ma-0 px-4">
												<v-col class="px-4 pt-0 pb-0" cols="12">
													<v-switch
														inset
														label="Importa riferimenti Fatture in Preventivi"
														color="primary"
														v-model="settings['import_document_references']"
														:disabled="disabledQuotation"
													></v-switch>
												</v-col>													
											</v-row>
										</v-container>
									</v-card>

									<v-card color="background-2 round-card" class="mb-5">
										<v-subheader>Uscita</v-subheader>
										<v-container class="pa-0" fluid>
											<v-row class="ma-0 px-4">
												<v-col class="px-4 pt-0 pb-0" cols="12">
													<v-switch
														inset
														label="Preventivi"
														color="primary"
														v-model="settings['export_quotations']"
														:disabled="disabledQuotation"
													></v-switch>
												</v-col>
												<v-col class="px-4 pt-0" cols="12" lg="3" v-if="['gamma_sprint'].includes(settings['integrated_application'])">
													<v-combobox
														label="Tipo Documento"
														hint="Inserisci il codice documento con cui esportare i preventivi"
														persistent-hint
														v-model="settings['export_quotation_document']"
														small-chips
														:disabled="!settings['export_quotations']"
														outlined
														dense
													></v-combobox>
												</v-col>
											</v-row>
										</v-container>
									</v-card>
									

									<v-btn class="my-4" color="primary" @click="stepIndex++">Continua</v-btn>
									<v-btn class="my-4" @click="stepIndex--" text>Indietro</v-btn>
								</v-stepper-content>

								<v-stepper-step editable :complete="stepIndex > 5" step="5"><span class="body-2">Ordini</span></v-stepper-step>
								<v-stepper-content step="5">

									<v-card color="background-2 round-card" class="mb-5">
										<v-subheader>Entrata</v-subheader>
										<v-container class="pa-0" fluid>
																					<v-row class="ma-0 px-4">
												<v-col class="px-4 pt-0 pb-0" cols="12">
													<v-switch
														inset
														label="Importa riferimenti Fatture in Ordini di vendita"
														color="primary"
														v-model="settings['import_document_references_on_saleorders']"
														:disabled="disabledSaleorder"
													></v-switch>
												</v-col>													
											</v-row>
										</v-container>
									</v-card>

									<v-card color="background-2 round-card" class="mb-5">
										<v-subheader>Uscita</v-subheader>
										<v-container class="pa-0" fluid>
											<v-row class="ma-0 px-4">
												<v-col class="px-4 pt-0 pb-0" cols="12">
													<v-switch
														inset
														label="Ordini di vendita"
														color="primary"
														v-model="settings['export_saleorders']"
														:disabled="disabledSaleorder"
													></v-switch>
												</v-col>
												<v-col class="px-4 pt-0" cols="12" lg="3" v-if="['business_cube'].includes(settings['integrated_application'])">
													<v-switch
														inset
														label="Raggruppa spese accessorie"
														hint="Scegli se raggruppare le voci di spese accessorie come unico importo di piede su BC"
														persistent-hint
														v-model="settings['export_saleorder_sum_cost']"
														:disabled="!settings['export_saleorders']"
													></v-switch>
												</v-col>
												<v-col class="px-4 pt-0" cols="12" lg="3" v-if="['business_cube'].includes(settings['integrated_application'])">
													<v-combobox
														label="Tipo Bolla/Fattura"
														hint="Inserisci il codice per il tipo Bolla/Fattura"
														persistent-hint
														v-model="settings['export_saleorder_tipobf']"
														small-chips
														:disabled="!settings['export_saleorders']"
														outlined
														dense
													></v-combobox>
												</v-col>
												<v-col class="px-4 pt-0" cols="12" lg="3" v-if="info.saleorder_status && ['business_cube'].includes(settings['integrated_application'])">
													<v-autocomplete
														label="Stati ordini da esportare"
														hint="Seleziona gli stati degli ordini da esportare"
														persistent-hint
														:items="info.saleorder_status"
														v-model="settings['export_saleorder_status_included']"
														small-chips
														:disabled="!settings['export_saleorders']"
														multiple
														item-text="text"
														item-value="value"
														outlined
														dense
													></v-autocomplete>
												</v-col>
											</v-row>
										</v-container>
									</v-card>


									<v-btn class="my-4" color="primary" @click="stepIndex++">Continua</v-btn>
									<v-btn class="my-4" @click="stepIndex--" text>Indietro</v-btn>
								</v-stepper-content>

								<v-stepper-step editable :complete="stepIndex > 6" step="6"><span class="body-2">DDT</span></v-stepper-step>
								<v-stepper-content step="6">
									<v-card color="background-2 round-card" class="mb-3">
										<v-subheader>Entrata</v-subheader>
										<v-container class="pa-0" fluid>
											<v-row class="ma-0 px-4">
												<v-col class="px-4 pt-0 pb-0" cols="12">
													<v-switch
														inset
														label="DDT"
														color="primary"
														v-model="settings['import_ddts']"
														:disabled="disabledDdt"
													></v-switch>
												</v-col>
												<v-col class="px-4 pt-0 pb-2" cols="12" lg="3">
													<v-combobox
														label="Causali escluse"
														hint="Inserisci i codici delle causali da non importare"
														persistent-hint
														v-model="settings['ddtscausal_exluded']"
														small-chips
														:disabled="!settings['import_ddts']"
														multiple
														return-object
														item-text="label"
														item-value="key"
														outlined
														dense
													></v-combobox>
												</v-col>	
											</v-row>
										</v-container>
									</v-card>
									<v-card color="background-2 round-card" class="mb-3">
										<v-subheader>Uscita</v-subheader>
										<v-container class="pa-0" fluid >
											<v-row class="ma-0 px-4">
												<v-col class="px-4 pt-0 pb-0" cols="12">
													<v-switch
														inset
														label="DDT"
														color="primary"
														v-model="settings['export_ddts']"
														:disabled="disabledDdt"
													></v-switch>
												</v-col>
												<v-col class="px-4 pt-0" cols="12" lg="3" v-if="settings['integrated_application'] == 'gamma_sprint'">
													<v-combobox
														label="Tipo Documento"
														hint="Inserisci il codice documento con cui esportare i ddt"
														persistent-hint
														v-model="settings['export_ddt_document']"
														small-chips
														:disabled="!settings['export_ddts']"
														outlined
														dense
													></v-combobox>
												</v-col>
											</v-row>
										</v-container>
									</v-card>
									<v-btn class="my-4" color="primary" @click="stepIndex++">Continua</v-btn>
									<v-btn class="my-4" @click="stepIndex--" text>Indietro</v-btn>
								</v-stepper-content>
								
								
								<v-stepper-step editable :complete="stepIndex > 7" step="7"><span class="body-2">Fatture</span></v-stepper-step>
								<v-stepper-content step="7">
									<v-card color="background-2 round-card" class="mb-3">
										<v-subheader>Entrata</v-subheader>
										<v-container class="pa-0" fluid>
											<v-row class="ma-0 px-4">
												<v-col class="px-4 pt-0 pb-0" cols="12">
													<v-switch
														inset
														label="Fatture"
														color="primary"
														v-model="settings['import_invoices']"
														:disabled="disabledInvoice"
													></v-switch>
												</v-col>
											</v-row>
										</v-container>
									</v-card>
									<v-card color="background-2 round-card" class="mb-3">
										<v-subheader>Uscita</v-subheader>
										<v-container class="pa-0" fluid >
											<v-row class="ma-0 px-4">
												<v-col class="px-4 pt-0 pb-0" cols="12">
													<v-switch
														inset
														label="Fatture"
														color="primary"
														v-model="settings['export_saleinvoices']"
														:disabled="disabledInvoice"
													></v-switch>
												</v-col>
												<v-col class="px-4 pt-0" cols="12" lg="3" v-if="settings['integrated_application'] == 'gamma_sprint'">
													<v-combobox
														label="Tipo Documento"
														hint="Inserisci il codice documento con cui esportare le Fatture"
														persistent-hint
														v-model="settings['export_saleinvoice_document']"
														small-chips
														:disabled="!settings['export_saleinvoices']"
														outlined
														dense
													></v-combobox>
												</v-col>
												<v-col class="px-4 pt-0 pb-0" cols="12">
													<v-switch
														inset
														label="Note di Credito"
														color="primary"
														v-model="settings['export_creditnotes']"
														:disabled="disabledInvoice"
													></v-switch>
												</v-col>
												<v-col class="px-4 pt-0" cols="12" lg="3" v-if="settings['integrated_application'] == 'gamma_sprint'">
													<v-combobox
														label="Tipo Documento"
														hint="Inserisci il codice documento con cui esportare le Note di Credito"
														persistent-hint
														v-model="settings['export_creditnote_document']"
														small-chips
														:disabled="!settings['export_creditnotes']"
														outlined
														dense
													></v-combobox>
												</v-col>														
											</v-row>
										</v-container>
									</v-card>
									<v-btn class="my-4" color="primary" @click="stepIndex++">Continua</v-btn>
									<v-btn class="my-4" @click="stepIndex--" text>Indietro</v-btn>
								</v-stepper-content>


								<v-stepper-step editable :complete="stepIndex > 8" step="8"><span class="body-2">Prodotti</span></v-stepper-step>
								<v-stepper-content step="8">
									<v-card color="background-2 round-card" class="mb-5">
										<v-subheader>Entrata</v-subheader>
										<v-container class="pa-0" fluid>
											<v-row class="ma-0 px-4">
												<v-col class="px-4 pt-0 pb-0" cols="12">
													<v-switch
														inset
														label="Prodotti"
														color="primary"
														v-model="settings['import_products']"
													></v-switch>
												</v-col>
												<v-col class="px-4 pt-0 pb-2" cols="12" lg="3">
													<v-combobox
														label="Famiglie escluse"
														hint="Inserisci i codici delle famiglie da non importare"
														persistent-hint
														v-model="settings['import_productcategories_exluded']"
														small-chips
														:disabled="!settings['import_products']"
														multiple
														return-object
														item-text="label"
														item-value="key"
														outlined
														dense
													></v-combobox>
												</v-col>
												<v-col class="px-4 pt-0 pb-2" cols="12">
													<v-switch v-if="['gamma_sprint', 'business_cube'].includes(settings['integrated_application']) && settings['import_products']"
														inset
														label="Aggiorna Descrizione"
														color="primary"
														v-model="settings['update_products_description']"
														hide-details
													></v-switch>
													<v-switch v-if="['gamma_sprint', 'gamma_evolution', 'business_cube'].includes(settings['integrated_application']) && settings['import_products']"
														inset
														label="Listini Prodotti"
														color="primary"
														v-model="settings['import_pricelists_products']"
														hide-details
													></v-switch>
													<v-switch v-if="settings['integrated_application'] == 'business_cube' && settings['import_products']"
														inset
														label="Importa Immagini"
														color="primary"
														v-model="settings['import_product_images']"
														hide-details
													></v-switch>
													<v-switch v-if="settings['integrated_application'] == 'gamma_sprint' && settings['import_products']"
														inset
														label="Ubicazioni Prodotti"
														color="primary"
														v-model="settings['import_site_products']"
														hide-details
													></v-switch>
													<v-switch v-if="settings['integrated_application'] == 'gamma_sprint' && settings['import_products']"
														inset
														label="Disabilita Prodotti non letti"
														color="primary"
														v-model="settings['disable_products']"
														hide-details
													></v-switch>
													<v-switch v-if="settings['import_products']"
														inset
														label="Importa Giacenze"
														color="primary"
														v-model="settings['import_stocks']"
														hide-details
													></v-switch>
												</v-col>														
											</v-row>
										</v-container>
									</v-card>

									<v-card color="background-2 round-card" class="mb-5">
										<v-subheader>Uscita</v-subheader>
										<v-container class="pa-0" fluid >
											<v-row class="ma-0 px-4">
												<v-col class="px-4 pt-0 pb-2" cols="12">
													<v-switch
														inset
														label="Prodotti"
														color="primary"
														v-model="settings['export_products']"
													></v-switch>
													<v-switch v-if="settings['export_products']"
														inset
														label="Esporta solo Prodotti Nuovi"
														color="primary"
														v-model="settings['export_products_only_new']"
													></v-switch>
													<v-switch v-if="settings['integrated_application'] == 'gamma_sprint'"
														inset
														label="Listini Prodotti"
														color="primary"
														v-model="settings['export_pricelists_products']"
														hide-details
													></v-switch>															
													<v-switch v-if="settings['export_products']"
														inset
														label="Esporta Giacenze"
														color="primary"
														v-model="settings['export_stocks']"
														hide-details
													></v-switch>											
												</v-col>
												<v-col class="px-4 pt-0 pb-2" cols="12" lg="3" >
													<v-combobox
														label="Famiglie escluse"
														hint="Inserisci i codici delle famiglie da non esportare"
														persistent-hint
														v-model="settings['export_productcategories_exluded']"
														small-chips
														:disabled="!settings['export_products']"
														multiple
														return-object
														item-text="label"
														item-value="key"
														outlined
														dense
													></v-combobox>
												</v-col>	
											</v-row>
										</v-container>
									</v-card>
									<v-btn class="my-4" color="primary" @click="stepIndex++">Continua</v-btn>
									<v-btn class="my-4" @click="stepIndex--" text>Indietro</v-btn>
								</v-stepper-content>


								<v-stepper-step editable :complete="stepIndex > 9" step="9"><span class="body-2">Asset</span></v-stepper-step>
								<v-stepper-content step="9">
									<v-card color="background-2 round-card" class="mb-5">
										<v-subheader>Entrata</v-subheader>
										<v-container class="pa-0" fluid >
											<v-row class="ma-0 px-4">
												<v-col class="px-4 pt-0 pb-0" cols="12">
													<v-switch
														inset
														label="Asset"
														color="primary"
														v-model="settings['import_assets']"
														:disabled="disabledAsset"
													></v-switch>
												</v-col>
											</v-row>
										</v-container>
									</v-card>
									<v-btn class="my-4" color="primary" @click="stepIndex++">Continua</v-btn>
									<v-btn class="my-4" @click="stepIndex--" text>Indietro</v-btn>
								</v-stepper-content>	


								<v-stepper-step editable :complete="stepIndex > 10" step="10"><span class="body-2">Agenti</span></v-stepper-step>
								<v-stepper-content step="10">
									<v-card color="background-2 round-card" class="mb-5">
										<v-subheader>Entrata</v-subheader>
										<v-container class="pa-0" fluid>
											<v-row class="ma-0 px-4">
												<v-col class="px-4 pt-0 pb-0" cols="12">
													<v-switch
														inset
														label="Agenti"
														color="primary"
														v-model="settings['import_agents']"
														:disabled="disabledAgent"
													></v-switch>
												</v-col>
											</v-row>
										</v-container>
									</v-card>
									<v-btn class="my-4" color="primary" @click="stepIndex++">Continua</v-btn>
									<v-btn class="my-4" @click="stepIndex--" text>Indietro</v-btn>
								</v-stepper-content>									


								<v-stepper-step editable :complete="stepIndex > 11" step="11"><span class="body-2">Ticket</span></v-stepper-step>
								<v-stepper-content step="11">
									<v-card color="background-2 round-card" class="mb-5">
										<v-subheader>Uscita</v-subheader>
										<v-container class="pa-0" fluid>
											<v-row class="ma-0 px-4">
												<v-col class="px-4 pt-0 pb-0" cols="12">
													<v-switch
														inset
														label="Ticket"
														color="primary"
														v-model="settings['export_troubles']"
														:disabled="disabledTrouble"
													></v-switch>
												</v-col>
												<v-col class="px-4 pt-0" cols="12" lg="3" v-if="settings['integrated_application'] == 'gamma_evolution'">
													<v-combobox
														label="Tipo Documento"
														hint="Inserisci il codice documento con cui esportare i ticket"
														persistent-hint
														v-model="settings['export_trouble_document']"
														small-chips
														:disabled="!settings['export_troubles']"
														outlined
														dense
													></v-combobox>
												</v-col>
												<v-col class="px-4 pt-0" cols="12" lg="3" v-if="settings['integrated_application'] == 'gamma_evolution'">
													<v-combobox
														label="Sezionale"
														hint="Inserisci il codice del sezionale con cui esportare i ticket"
														persistent-hint
														v-model="settings['export_trouble_sectional']"
														small-chips
														:disabled="!settings['export_troubles']"
														outlined
														dense
													></v-combobox>
												</v-col>
												<v-col class="px-4 pt-0" cols="12" lg="3" v-if="settings['integrated_application'] == 'ficv2'">
													<v-text-field
														label="Sezionale"
														hint="Inserisci il codice del sezionale con cui esportare i ticket"
														persistent-hint
														v-model="settings['export_troubles_sectional']"
														:disabled="!settings['export_troubles']"
														outlined
														dense
													></v-text-field>
												</v-col>
												<!--<v-col class="px-4 pt-0" cols="12" lg="3" v-if="info.sectionals && settings['integrated_application'] == 'gamma_sprint'">
													<v-autocomplete
														label="Sezionali"
														hint="Inserisci il sezionale con cui esportare i ticket"
														persistent-hint
														:items="info.sectionals"
														v-model="settings['export_ticket_sectional']"
														small-chips
														:disabled="!settings['export_troubles']"
														item-text="name"
														item-value="id"
														outlined
														dense
													></v-autocomplete>
												</v-col>-->
												<v-col class="px-4 pt-2 pb-0" cols="12">
													<v-switch
														inset
														label="Esporta Ticket con imponibile 0"
														color="primary"
														v-model="settings['export_troubles_zero']"
														:disabled="disabledTrouble"
													></v-switch>
												</v-col>
												<v-col class="px-4 pt-2 pb-0" cols="12" v-if="settings['integrated_application'] == 'gamma_evolution'">
													<v-switch
														inset
														label="Includi la Richiesta da parte del cliente nel ticket"
														color="primary"
														v-model="settings['export_troubles_request']"
														:disabled="disabledTrouble"
													></v-switch>
												</v-col>
												<v-col class="px-4 pt-2 pb-0" cols="12">
													<v-switch
														inset
														label="Esporta con data di chiusura Ticket"
														color="primary"
														v-model="settings['export_closed_date']"
														:disabled="disabledTrouble"
													></v-switch>
												</v-col>
												<v-col class="px-4 pb-2" cols="12" lg="4">
													<v-text-field
														label="Codice prodotto per ore intervento"
														v-model="settings['productcode_hours']"
														:disabled="disabledTrouble"
														outlined
														dense
													></v-text-field>
												</v-col>
												<v-col class="px-4 pt-2 pb-0" cols="12">
													<v-switch
														inset
														label="Inserisci fascia oraria su descrizione intervento"
														color="primary"
														v-model="settings['insert_time_slot']"
														:disabled="disabledTrouble"
													></v-switch>
												</v-col>
												<v-col class="px-4 pb-2" cols="12" lg="4" >
													<v-text-field
														label="Descrizione prodotto per ore intervento"
														v-model="settings['productdesc_hours']"
														:disabled="disabledTrouble"
														outlined
														dense
													></v-text-field>
												</v-col>
											</v-row>
										</v-container>
									</v-card>
									<v-btn @click="stepIndex--" text>Indietro</v-btn>
								</v-stepper-content>
							</v-stepper>
						</v-col>
					</v-row>
					
					<v-divider></v-divider>
					
					<v-card-actions>
						<v-btn class="mx-2" @click="integrationImport()" outlined dense color="blue">Sinc. ora in entrata</v-btn>
						<v-btn class="mx-2" @click="integrationExport()" outlined dense color="green">Sinc. ora in uscita</v-btn>
						<v-spacer></v-spacer>
						<v-btn class="my-2" text @click="saveIntegrationsSetting()" color="primary">Salva</v-btn>
					</v-card-actions>
				</v-card>
			</v-container>
		</v-tab-item>

		<v-tab-item :key="2" class="pb-offset background-1 pt-3">
			<custom-integrations></custom-integrations>
		</v-tab-item>

		<v-tab-item :key="3" class="pb-offset background-1 pt-3">
			<settings-integrations-apps></settings-integrations-apps>
		</v-tab-item>
		
		<v-tab-item :key="4" class="pb-offset background-1 pt-3">
			<crud
				title=''
				action-icon='settings'
				model-def='integrationwebsites'
				action-position='absolute'
				:redirect="{back:-1}"
			></crud>
		</v-tab-item>

	</v-tabs>

</template>
<script>

	import SettingsIntegrationsApps from '@/components/modules/settings/SettingsIntegrationsApps'
	import CustomIntegrations from '@/components/modules/settings/CustomIntegrations'

	export default {
		name:'settings-integrations',
        components: {
            SettingsIntegrationsApps,
            CustomIntegrations,
        },
		data() {
			return {
				stepIndex: 1,
				settings: {
					integrated_application: 'nothing',
					integration_type: 'server',
					companies: false,
					agents: false,
					products: false,
					ddts: false,
					companycategories_exluded: [],
					companyareas_exluded: [],
					productcategories_exluded: [],
					ddtscausal_exluded: [],
					export_troubles_request: false,
				},
				info: {},
			}
		},

		created() {
			this.axios.get('integrationssettings').then(response => {
			    // get body data
			    if( typeof response.data.data !== 'undefined' && Object.keys(response.data.data).length > 0) {
			   		this.settings = response.data.data
				}
			   		this.info = response.data.info
			   	this.$store.commit('endProgress')

			}, response => {
			    // error callback
			})
		},

		methods: {
			validateSyncType() {
				this.$validator.validateAll().then(result => {
					if (!result) {
						return false
					}

					this.stepIndex++

				}).catch(() => {

				})	
			},

			saveIntegrationsSetting() {
				this.axios.post('integrationssettings', this.settings).then(response => {
				    // get body data
					this.$store.commit('setSnackbar', {timeout: 6000, text: 'Impostazioni salvate', value: true, color: 'success'})
					//this.$store.commit('SET_SETTINGS', response.data.settings)
				}, response => {
				    // error callback
				});
			},

			integrationImport() {
				this.axios.get('import').then(response => {
				    // get body data
					this.$store.commit('setSnackbar', {timeout: 6000, text: 'Importazione avviata', value: true, color: 'success'})
				}, response => {
				    // error callback
				});
			},

			integrationExport() {
				this.axios.get('export').then(response => {
					// get body data
					this.$store.commit('setSnackbar', {timeout: 6000, text: 'Esportazione avviata', value: true, color: 'success'})
				}, response => {
				    // error callback
				});
			},

			gestIntegratedApplication() {
				if(this.settings['integrated_application'] == 'reviso') {
					this.stepIndex = 3
				} else this.stepIndex = 2
			},

			backIntegretedApplication() {
				if(this.settings['integrated_application'] == 'reviso') {
					this.stepIndex -= 2
				} else this.stepIndex--
			},

			loginReviso() {
				window.open(this.info['reviso_url'], '_blank');
			},

			loginFIC() {
				this.axios.get('ficurl').then((resp) => {
					window.open(resp.data.url, '_blank');
				})
			}

		},

		computed: {
			disabledQuotation() {
				return !this.$store.getters.checkModulePermissions('quotations') || ['reviso', 'os1'].includes(this.settings['integrated_application'])
			},

			disabledSaleorder() {
				return !this.$store.getters.checkModulePermissions('orders') || !['business_cube'].includes(this.settings['integrated_application'])
			},

			disabledDdt() {
				return !this.$store.getters.checkModulePermissions('ddts') || ['os1'].includes(this.settings['integrated_application'])
			},
			
			disabledInvoice() {
				return !(this.$store.getters.checkModulePermissions('invoices') && ['reviso', 'fic', 'ficv2', 'gamma_sprint'].includes(this.settings['integrated_application']))
			},

			disabledAsset() {
				return !this.$store.getters.checkModulePermissions('assets') || ['reviso', 'os1'].includes(this.settings['integrated_application'])
			},

			disabledAgent() {
				return !this.$store.getters.checkModulePermissions('agents') || ['smack', 'os1'].includes(this.settings['integrated_application'])
			},

			disabledTrouble() {
				return !this.$store.getters.checkModulePermissions('tickets') || ['reviso', 'os1'].includes(this.settings['integrated_application'])
			}
		},
	}
</script>
